import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const searchQueryPerformanceStatsSchema = z.object({
  // Previous period metrics are all left optional since we don't need them in the request that groups by reporting date
  search_query_score: z.number(),
  search_query_score_prev: z.number().nullable().optional(),
  search_query_score_delta: z.number().nullable().optional(),
  search_query_score_percent: z.number().nullable().optional(),

  search_query_volume: z.number(),
  search_query_volume_prev: z.number().nullable().optional(),
  search_query_volume_delta: z.number().nullable().optional(),
  search_query_volume_percent: z.number().nullable().optional(),

  impressions_total: z.number(),
  impressions_total_prev: z.number().nullable().optional(),
  impressions_total_delta: z.number().nullable().optional(),
  impressions_total_percent: z.number().nullable().optional(),

  impressions_asin_total: z.number().optional(),
  impressions_asin_total_prev: z.number().nullable().optional(),
  impressions_asin_total_delta: z.number().nullable().optional(),
  impressions_asin_total_percent: z.number().nullable().optional(),

  impressions_asin_share: z.number(),
  impressions_asin_share_prev: z.number().nullable().optional(),
  impressions_asin_share_delta: z.number().nullable().optional(),
  impressions_asin_share_percent: z.number().nullable().optional(),

  impressions_brand_or_asin: z.number(),
  impressions_brand_or_asin_prev: z.number().nullable().optional(),
  impressions_brand_or_asin_delta: z.number().nullable().optional(),
  impressions_brand_or_asin_percent: z.number().nullable().optional(),

  clicks_total: z.number(),
  clicks_total_prev: z.number().nullable().optional(),
  clicks_total_delta: z.number().nullable().optional(),
  clicks_total_percent: z.number().nullable().optional(),

  clicks_asin_total: z.number().optional(),
  clicks_asin_total_prev: z.number().nullable().optional(),
  clicks_asin_total_delta: z.number().nullable().optional(),
  clicks_asin_total_percent: z.number().nullable().optional(),

  clicks_brand_or_asin: z.number(),
  clicks_brand_or_asin_prev: z.number().nullable().optional(),
  clicks_brand_or_asin_delta: z.number().nullable().optional(),
  clicks_brand_or_asin_percent: z.number().nullable().optional(),

  clicks_asin_share: z.number(),
  clicks_asin_share_prev: z.number().nullable().optional(),
  clicks_asin_share_delta: z.number().nullable().optional(),
  clicks_asin_share_percent: z.number().nullable().optional(),

  clicks_total_rate: z.number(),
  clicks_total_rate_prev: z.number().nullable().optional(),
  clicks_total_rate_delta: z.number().nullable().optional(),
  clicks_total_rate_percent: z.number().nullable().optional(),

  clicks_same_day_shipping_speed: z.number(),
  clicks_same_day_shipping_speed_prev: z.number().nullable().optional(),
  clicks_same_day_shipping_speed_delta: z.number().nullable().optional(),
  clicks_same_day_shipping_speed_percent: z.number().nullable().optional(),

  clicks_1d_shipping_speed: z.number(),
  clicks_1d_shipping_speed_prev: z.number().nullable().optional(),
  clicks_1d_shipping_speed_delta: z.number().nullable().optional(),
  clicks_1d_shipping_speed_percent: z.number().nullable().optional(),

  clicks_2d_shipping_speed: z.number(),
  clicks_2d_shipping_speed_prev: z.number().nullable().optional(),
  clicks_2d_shipping_speed_delta: z.number().nullable().optional(),
  clicks_2d_shipping_speed_percent: z.number().nullable().optional(),

  cart_adds_total: z.number(),
  cart_adds_total_prev: z.number().nullable().optional(),
  cart_adds_total_delta: z.number().nullable().optional(),
  cart_adds_total_percent: z.number().nullable().optional(),

  cart_adds_total_rate: z.number(),
  cart_adds_total_rate_prev: z.number().nullable().optional(),
  cart_adds_total_rate_delta: z.number().nullable().optional(),
  cart_adds_total_rate_percent: z.number().nullable().optional(),

  cart_adds_brand_or_asin: z.number(),
  cart_adds_brand_or_asin_prev: z.number().nullable().optional(),
  cart_adds_brand_or_asin_delta: z.number().nullable().optional(),
  cart_adds_brand_or_asin_percent: z.number().nullable().optional(),

  cart_adds_asin_share: z.number().optional(),
  cart_adds_asin_share_prev: z.number().nullable().optional(),
  cart_adds_asin_share_delta: z.number().nullable().optional(),
  cart_adds_asin_share_percent: z.number().nullable().optional(),

  cart_adds_same_day_shipping_speed: z.number(),
  cart_adds_same_day_shipping_speed_prev: z.number().nullable().optional(),
  cart_adds_same_day_shipping_speed_delta: z.number().nullable().optional(),
  cart_adds_same_day_shipping_speed_percent: z.number().nullable().optional(),

  cart_adds_1d_shipping_speed: z.number(),
  cart_adds_1d_shipping_speed_prev: z.number().nullable().optional(),
  cart_adds_1d_shipping_speed_delta: z.number().nullable().optional(),
  cart_adds_1d_shipping_speed_percent: z.number().nullable().optional(),

  cart_adds_2d_shipping_speed: z.number(),
  cart_adds_2d_shipping_speed_prev: z.number().nullable().optional(),
  cart_adds_2d_shipping_speed_delta: z.number().nullable().optional(),
  cart_adds_2d_shipping_speed_percent: z.number().nullable().optional(),

  purchases_total: z.number(),
  purchases_total_prev: z.number().nullable().optional(),
  purchases_total_delta: z.number().nullable().optional(),
  purchases_total_percent: z.number().nullable().optional(),

  purchases_total_rate: z.number(),
  purchases_total_rate_prev: z.number().nullable().optional(),
  purchases_total_rate_delta: z.number().nullable().optional(),
  purchases_total_rate_percent: z.number().nullable().optional(),

  purchases_brand_or_asin: z.number(),
  purchases_brand_or_asin_prev: z.number().nullable().optional(),
  purchases_brand_or_asin_delta: z.number().nullable().optional(),
  purchases_brand_or_asin_percent: z.number().nullable().optional(),

  purchases_brand_or_asin_share: z.number().optional(),
  purchases_brand_or_asin_share_prev: z.number().nullable().optional(),
  purchases_brand_or_asin_share_delta: z.number().nullable().optional(),
  purchases_brand_or_asin_share_percent: z.number().nullable().optional(),

  purchases_same_day_shipping_speed: z.number(),
  purchases_same_day_shipping_speed_prev: z.number().nullable().optional(),
  purchases_same_day_shipping_speed_delta: z.number().nullable().optional(),
  purchases_same_day_shipping_speed_percent: z.number().nullable().optional(),

  purchases_1d_shipping_speed: z.number(),
  purchases_1d_shipping_speed_prev: z.number().nullable().optional(),
  purchases_1d_shipping_speed_delta: z.number().nullable().optional(),
  purchases_1d_shipping_speed_percent: z.number().nullable().optional(),

  purchases_2d_shipping_speed: z.number(),
  purchases_2d_shipping_speed_prev: z.number().nullable().optional(),
  purchases_2d_shipping_speed_delta: z.number().nullable().optional(),
  purchases_2d_shipping_speed_percent: z.number().nullable().optional(),

  clicks_price_median: z.number().optional(),
  clicks_price_median_prev: z.number().nullable().optional(),
  clicks_price_median_delta: z.number().nullable().optional(),
  clicks_price_median_percent: z.number().nullable().optional(),

  clicks_brand_or_asin_price_median: z.number().optional(),
  clicks_brand_or_asin_price_median_prev: z.number().nullable().optional(),
  clicks_brand_or_asin_price_median_delta: z.number().nullable().optional(),
  clicks_brand_or_asin_price_median_percent: z.number().nullable().optional(),

  cart_adds_price_median: z.number().optional(),
  cart_adds_price_median_prev: z.number().nullable().optional(),
  cart_adds_price_median_delta: z.number().nullable().optional(),
  cart_adds_price_median_percent: z.number().nullable().optional(),

  cart_adds_brand_or_asin_price_median: z.number().optional(),
  cart_adds_brand_or_asin_price_median_prev: z.number().nullable().optional(),
  cart_adds_brand_or_asin_price_median_delta: z.number().nullable().optional(),
  cart_adds_brand_or_asin_price_median_percent: z.number().nullable().optional(),

  cart_adds_brand_or_asin_share: z.number().optional(),
  cart_adds_brand_or_asin_share_prev: z.number().nullable().optional(),
  cart_adds_brand_or_asin_share_delta: z.number().nullable().optional(),
  cart_adds_brand_or_asin_share_percent: z.number().nullable().optional(),

  purchases_price_median: z.number().optional(),
  purchases_price_median_prev: z.number().nullable().optional(),
  purchases_price_median_delta: z.number().nullable().optional(),
  purchases_price_median_percent: z.number().nullable().optional(),

  purchases_brand_or_asin_price_median: z.number().optional(),
  purchases_brand_or_asin_price_median_prev: z.number().nullable().optional(),
  purchases_brand_or_asin_price_median_delta: z.number().nullable().optional(),
  purchases_brand_or_asin_price_median_percent: z.number().nullable().optional(),

  ctr_total: z.number().optional(),
  ctr_total_prev: z.number().nullable().optional(),
  ctr_total_delta: z.number().nullable().optional(),
  ctr_total_percent: z.number().nullable().optional(),

  clicks_brand_or_asin_share: z.number().optional(),
  clicks_brand_or_asin_share_prev: z.number().nullable().optional(),
  clicks_brand_or_asin_share_delta: z.number().nullable().optional(),
  clicks_brand_or_asin_share_percent: z.number().nullable().optional(),

  ctr_brand_or_asin: z.number().optional(),
  ctr_brand_or_asin_prev: z.number().nullable().optional(),
  ctr_brand_or_asin_delta: z.number().nullable().optional(),
  ctr_brand_or_asin_percent: z.number().nullable().optional(),

  ctr_difference: z.number().optional(),
  ctr_difference_prev: z.number().nullable().optional(),
  ctr_difference_delta: z.number().nullable().optional(),
  ctr_difference_percent: z.number().nullable().optional(),

  cv_total: z.number().optional(),
  cv_total_prev: z.number().nullable().optional(),
  cv_total_delta: z.number().nullable().optional(),
  cv_total_percent: z.number().nullable().optional(),

  cv_brand_or_asin: z.number().optional(),
  cv_brand_or_asin_prev: z.number().nullable().optional(),
  cv_brand_or_asin_delta: z.number().nullable().optional(),
  cv_brand_or_asin_percent: z.number().nullable().optional(),

  cv_difference: z.number().optional(),
  cv_difference_prev: z.number().nullable().optional(),
  cv_difference_delta: z.number().nullable().optional(),
  cv_difference_percent: z.number().nullable().optional(),
});

export const searchQueryPerformanceReportApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "getV4SearchQueryPerformanceByQuery",
    method: "get",
    path: "/v4/query/?table=sqpr",
    parameters: [
      {
        name: "marketplace",
        type: "Query",
        schema: z.string(),
      },
      {
        name: "start_date",
        type: "Query",
        schema: z.string().datetime(),
      },
      {
        name: "end_date",
        type: "Query",
        schema: z.string().datetime(),
      },
      {
        name: "start_date_previous",
        type: "Query",
        schema: z.string().datetime(),
      },
      {
        name: "end_date_previous",
        type: "Query",
        schema: z.string().datetime(),
      },
      {
        name: "filters",
        type: "Query",
        schema: z
          .array(
            z.object({
              id: z.string(),
              value: z.object({
                op: z.string().transform((op) => {
                  return op;
                }),
                value: z.unknown(),
              }),
            }),
          )
          .optional(),
      },
      {
        name: "cursor",
        type: "Query",
        schema: z.number().optional(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().optional(),
      },
      {
        name: "ordering",
        type: "Query",
        schema: z.string().optional(),
      },
      {
        name: "search",
        type: "Query",
        schema: z.string().array().optional(),
      },
    ],
    status: 200,
    response: z.object({
      data: z.array(
        z
          .object({
            asin: z.string().optional(),
            org_id: z.number(),
            marketplace: z.string(),
            reporting_range: z.string().optional(),
            search_query: z.string(),
          })
          .merge(searchQueryPerformanceStatsSchema),
      ),
      cursor: z
        .object({
          hasPreviousPage: z.boolean(),
          hasNextPage: z.boolean(),
          startCursor: z.string().nullable(),
          endCursor: z.string().nullable(),
        })
        .nullable(),
      count: z.number(),
    }),
  })
    .addEndpoint({
      alias: "getV4SearchQueryPerformanceTotals",
      method: "get",
      path: "/v4/query/aggregate/?table=sqpr",
      parameters: [
        {
          name: "marketplace",
          type: "Query",
          schema: z.string(),
        },
        {
          name: "start_date",
          type: "Query",
          schema: z.string().datetime(),
        },
        {
          name: "end_date",
          type: "Query",
          schema: z.string().datetime(),
        },
        {
          name: "start_date_previous",
          type: "Query",
          schema: z.string().datetime(),
        },
        {
          name: "end_date_previous",
          type: "Query",
          schema: z.string().datetime(),
        },
        {
          name: "filters",
          type: "Query",
          schema: z
            .array(
              z.object({
                id: z.string(),
                value: z.object({
                  op: z.string().transform((op) => {
                    return op;
                  }),
                  value: z.unknown(),
                }),
              }),
            )
            .optional(),
        },

        {
          name: "search",
          type: "Query",
          schema: z.string().array().optional(),
        },
      ],
      status: 200,
      response: z.object({
        data: searchQueryPerformanceStatsSchema,
      }),
    })
    // getV4SearchQueryPerformanceByDate
    .addEndpoint({
      alias: "getV4SearchQueryPerformanceByDate",
      method: "get",
      path: "/v4/query/?table=sqpr&grouping=org_id,marketplace,reporting_date",
      parameters: [
        {
          name: "marketplace",
          type: "Query",
          schema: z.string(),
        },
        {
          name: "start_date",
          type: "Query",
          schema: z.string().datetime(),
        },
        {
          name: "end_date",
          type: "Query",
          schema: z.string().datetime(),
        },
        {
          name: "start_date_previous",
          type: "Query",
          schema: z.string().datetime().optional(),
        },
        {
          name: "end_date_previous",
          type: "Query",
          schema: z.string().datetime().optional(),
        },
        {
          name: "filters",
          type: "Query",
          schema: z
            .array(
              z.object({
                id: z.string(),
                value: z.object({
                  op: z.string().transform((op) => {
                    return op;
                  }),
                  value: z.unknown(),
                }),
              }),
            )
            .optional(),
        },

        {
          name: "search",
          type: "Query",
          schema: z.string().array().optional(),
        },
      ],
      status: 200,
      response: z.object({
        data: z.array(z.object({ reporting_date: z.string().date() }).merge(searchQueryPerformanceStatsSchema)),
      }),
    })
    .build(),
);
